import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import { findIndex as _findIndex, find as _find } from 'lodash';
var MAX_SIZE = 100;

var CacheFifo = /*#__PURE__*/function () {
  function CacheFifo(maxSize) {
    _classCallCheck(this, CacheFifo);

    this.data = [];
    this.maxSize = maxSize || MAX_SIZE;
  }

  _createClass(CacheFifo, [{
    key: "add",
    value: function add(record) {
      this.data.push(record);

      if (this.size() > this.maxSize) {
        this.remove();
      }
    }
  }, {
    key: "remove",
    value: function remove() {
      this.data.shift();
    }
  }, {
    key: "addOrUpdate",
    value: function addOrUpdate(record) {
      var existingRecordIndex = this.findIndexByKey(record.cacheKey);

      if (existingRecordIndex !== -1) {
        this.data[existingRecordIndex] = record;
      } else {
        this.add(record);
      }
    }
  }, {
    key: "first",
    value: function first() {
      return this.data[0];
    }
  }, {
    key: "last",
    value: function last() {
      return this.data[this.data.length - 1];
    }
  }, {
    key: "size",
    value: function size() {
      return this.data.length;
    }
  }, {
    key: "findIndexByKey",
    value: function findIndexByKey(cacheKey) {
      return _findIndex(this.data, {
        cacheKey: cacheKey
      });
    }
  }, {
    key: "findByKey",
    value: function findByKey(cacheKey) {
      return _find(this.data, {
        cacheKey: cacheKey
      });
    }
  }]);

  return CacheFifo;
}();

export default CacheFifo;